import React, { useState } from "react";
import { tableIcons } from "../../utils/TableIcons";
import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";
import { Visibility } from "@material-ui/icons";

const TableComponent = (props) => {
    const [state, setState] = React.useState([{ id: 1, name: "hello" }]);

    return (
        <div style={{ marginTop: 50, display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>

            <MaterialTable
                    icons={tableIcons}
                    // title="Users"
                    columns={props.columnNames}
                    data={state}
                    options={{
                        headerStyle: { backgroundColor: "#40404c", whiteSpace: "nowrap", color: "#e5e5e5" },
                        rowStyle: {
                            backgroundColor: '#2b2b39',
                            color: "#fff"
                        }
                        // actionsCellStyle: { backgroundColor: "lightgrey" },
                    }}
                    // actions={[
                    //     {
                    //         icon: () => <Visibility color="primary" />,
                    //         iconProps: { style: { fontSize: "14px", color: "green" } },
                    //         tooltip: "View Article",
                    //         onClick: (event, rowData) => alert("You saved " + rowData.title),
                    //     },
                    // ]}
                    editable={{
                        onRowAdd: (newData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    setState((prevState) => {
                                        const data = [...prevState.data];
                                        data.push(newData);
                                        return { ...prevState, data };
                                    });
                                }, 600);
                            }),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    if (oldData) {
                                        setState((prevState) => {
                                            const data = [...prevState.data];
                                            data[data.indexOf(oldData)] = newData;
                                            return { ...prevState, data };
                                        });
                                    }
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    setState((prevState) => {
                                        const data = [...prevState.data];
                                        data.splice(data.indexOf(oldData), 1);
                                        return { ...prevState, data };
                                    });
                                }, 600);
                            }),
                    }}
                    components={{
                        Toolbar: props => (
                            <div>
                            </div>
                        ),
                    }}
                />

        </div>
    );
};

export default TableComponent;